import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SUB_TYPE, USER_TYPE, ValidationMsgs, datePicker_no_range, infoMsg, validity_date_v2 } from 'src/app/core/Constants/static';
import { RuleConfigDetails, RuleConfigListing, drugInFormInHand } from 'src/app/core/Models/interfaces/ruleconfig';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { ProvPayerApiService } from '../../../provider_insurance/services/prov-payer-api.service';
import { RuleConfigManageService } from '../../services/rule-config-manage.service';
import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';
import { ClientRuleService } from '../../services/client-rule.service';
import { environment } from 'src/environments/environment';
import { PayerList } from 'src/app/core/Models/interfaces/payerList';
import { ProviderDetails } from 'src/app/core/Models/interfaces/providerDetails';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';
import { RuleConfiguration } from 'src/app/core/Models/interfaces/payloads/ruleConfiguration';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';

@Component({
  selector: 'app-rule-configuration-edit',
  templateUrl: './rule-configuration-edit.component.html',
  styleUrls: ['./rule-configuration-edit.component.css'],
})
export class RuleConfigurationEditComponent implements OnInit {
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input('selectedConfig') selectedConfig!: RuleConfigListing | null;
  @Input('isAddPage') isAddPage: boolean = false;
  @Input('systemConfigEdit') systemConfigEdit: boolean = false;

  private ruleConfigDetails!: RuleConfigDetails[];
  private subscriberType!: string;
  private payerId: number | undefined;
  private providerId: number | undefined;
  private page_limit: number = 10;

  public showSlider: boolean = false;
  public addConfigForm!: FormGroup;
  public startError: boolean = false;
  public validationMsg = ValidationMsgs.datePattern;
  public startDateError = ValidationMsgs.startDateError;
  public requiredMsgError = ValidationMsgs.requiredMsg;
  public infoMsg = infoMsg;
  public subTypes = SUB_TYPE
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  public payerList: PayerList[] = [];
  public providerList: ProviderDetails[] = [];
  public submitted: boolean = false;
  public user?: UserDetails;
  public isLoader: boolean = false;
  public drugInHand: drugInFormInHand[] = [];
  public page_no: number = 1;
  public showNavigation: boolean = false;
  public totalCount!: number;
  public validity_date_v2: InputDatepicker = datePicker_no_range;

  constructor(
    private ruleService: RuleConfigManageService,
    private userService: UserService,
    private toasterandloader: ToasterService,
    private provPayerApiService: ProvPayerApiService,
    private systemRuleService: ClientRuleService
  ) {
    this.user = this.userService.getUserInfo()?.userDetails;
  }

  public ngOnInit(): void {
    this.prepareForm();
    if (this.isAddPage) {
      this.getRuleConfigDetails();
    }
    else {
      this.addConfigForm?.controls?.['subscriberId']?.disable();
      this.addConfigForm?.controls?.['version']?.disable();
      this.addConfigForm?.controls?.['dispenseLimit']?.disable();
      this.addConfigForm?.controls?.['refill']?.disable();
      this.addConfigForm?.controls?.['maxDuration']?.disable();
      this.addConfigForm?.controls?.['validityStart']?.disable();
      this.addConfigForm?.controls?.['packSize']?.disable();
      this.addConfigForm?.controls?.['subType']?.disable();
      this.addConfigForm?.controls?.['considerDrugInHand']?.disable();
      this.addConfigForm?.controls?.['dispenseType']?.disable();

      if (this.systemConfigEdit) {
        this.getSystemRuleConFigDetails();
      }
    }
  }

  private prepareForm(): void {
    this.isLoader = true;
    this.addConfigForm = new FormGroup({
      subscriberId: new FormControl(null),
      subType: new FormControl(null),
      version: new FormControl(null, [Validators.required]),
      dispenseLimit: new FormControl(null, [Validators.required]),
      refill: new FormControl(null, [Validators.required]),
      maxDuration: new FormControl(null, [Validators.required]),
      validityStart: new FormControl(null, [
        Validators.required,
        CustomValidation.patternCheck,
        CustomValidation.checkDateWithToday,
      ]),
      validityEnd: new FormControl(null, [
        Validators.required,
        CustomValidation.patternCheck,
        CustomValidation.checkDateWithToday,
      ]),
      packSize: new FormControl('LOWCOST'),
      considerDrugInHand: new FormControl('ENABLED', [Validators.required]),
      dispenseType: new FormControl('STRIP/PACKET', [Validators.required]),

    });
    this.configureFormItems();
    this.isLoader = false;

  }

  private configureFormItems(): void {
    if (!this.systemConfigEdit) {
      if (this.selectedConfig && !this.isAddPage) {
        if (this.selectedConfig.subscriberType == 'payer' || this.selectedConfig.payerId) {
          this.addConfigForm?.controls?.['subType'].patchValue('payer');
          this.subscriberType = 'payer';

        }
        else if (this.selectedConfig.subscriberType == 'provider' || this.selectedConfig.providerId) {
          this.addConfigForm?.controls?.['subType'].patchValue('provider');
          this.subscriberType = 'provider';
        }
      }
      else {
        if(this.subTypeEvm=='both'){
          this.addConfigForm.controls['subType'].setValue('provider');
          if(this.user?.userType == USER_TYPE.payer){
            this.addConfigForm.controls['subType'].setValue('payer');
          }
        }
        else{
          this.addConfigForm?.controls?.['subType'].patchValue((this.subTypeEvm == 'provider') ? 'provider' : 'payer');
        }
      }
      if (this.addConfigForm?.controls?.['subType']?.value == 'provider') {
        this.getProviderList();
      }
      else {
        this.getPayersList();
      }
    }


    if (this.user?.userType == USER_TYPE?.system && !this.systemConfigEdit) {
      this.addConfigForm.controls['subscriberId']?.addValidators(Validators.required);
      this.addConfigForm.controls['subscriberId']?.updateValueAndValidity();
    }
    if (this.subTypeEvm == this.subTypes.provider) {
      this.addConfigForm.controls['subType'].setValue('provider');
      this.addConfigForm.controls['subType'].disable();
    }
    else if (this.subTypeEvm == this.subTypes.payer) {
      this.addConfigForm.controls['subType'].setValue('payer');
      this.addConfigForm.controls['subType'].disable();
    }
  }

  public setSubscriberType(event: Event): void {
    const item = event.target as HTMLInputElement
    if (item.value == 'payer') {
      this.subscriberType = 'payer';
      this.getPayersList();
    } else {
      this.subscriberType = 'provider';
      this.getProviderList();
    }
  }

  //fetch all providers when provider is seleted
  private getProviderList(): void {
    if (!this.providerList.length) {
      this.provPayerApiService.getProviderList().subscribe({
        next: (response) => {
          if (response) {
            this.providerList = response?.data?.data;
            if (!this.isAddPage) {
              this.getProvDetails();
            }
          }
        },
        error: (error) => {
        },
      });
    }
  }
  //fetch all payers when provider is seleted
  private getPayersList(): void {
    if (!this.payerList.length) {
      this.provPayerApiService.getPayerList().subscribe({
        next: (response) => {
          if (response) {
            this.payerList = response?.data?.data;
            if (!this.isAddPage) {
              this.getPayerDetails();
            }
          }
        },
        error: (error) => {
          // console.error(error.message);
        },
      });
    }
  }

  // fill the form with the fetched data.
  private SetRuleConfigValues(ruleConfigDetails: RuleConfigDetails[]) {
    ruleConfigDetails?.forEach((el) => {
      if (el?.configCode == 'LMTDISPQUNTY') {
        this.addConfigForm?.controls?.['dispenseLimit']?.patchValue(el?.configValue);
      }
      else if (el?.configCode == 'ALLOWREFILL') {
        this.addConfigForm?.controls?.['refill']?.patchValue(el?.configValue);
      }
      else if (el?.configCode == 'DRUGSELECTION') {
        this.addConfigForm?.controls?.['packSize']?.patchValue(el?.configValue);
      }
      else if (el?.configCode == 'MAXREFILL') {
        this.addConfigForm?.controls?.['maxDuration']?.patchValue(el?.configValue);
      }
      else if (el?.configCode == 'CONSIDER_DRUG_IN_HAND_METAKEY') {
        this.addConfigForm?.controls?.['considerDrugInHand']?.patchValue(el?.configValue);
      }
      else if (el?.configCode == 'DISPENSETYPE_METAKEY') {
        this.addConfigForm?.controls?.['dispenseType']?.patchValue(el?.configValue);
      }
    });
    const ruleDetails = ruleConfigDetails[0];
    this.addConfigForm?.controls?.['validityStart']?.patchValue(ruleDetails?.activeFrom?.split('-').reverse().join('/'));
    this.addConfigForm?.controls?.['validityEnd']?.patchValue(ruleDetails?.expiredOn?.split('-').reverse().join('/'));
    if (this.addConfigForm.controls['subType'].value === 'provider' && !this.systemConfigEdit) {
      this.addConfigForm?.controls?.['version']?.patchValue(ruleDetails?.providerRuleConfigurationVersion);
    }
    else if (this.addConfigForm.controls['subType'].value === 'payer' && !this.systemConfigEdit) {
      this.addConfigForm?.controls?.['version']?.patchValue(ruleDetails?.payerRuleConfigurationVersion);
    }
    else {
      this.addConfigForm?.controls?.['version']?.patchValue(ruleDetails?.ruleConfigurationVersion);
    }
  }

  //fetch a default data to prefill the add new form
  private getRuleConfigDetails(): void {
    this.isLoader = true;
    this.ruleService.getRuleConfigDetailsClient(this.user?.clientId).subscribe({
      next: (response: ApiResponse) => {
        if (response) {
          this.ruleConfigDetails = response?.data?.data;
          this.SetRuleConfigValues(this.ruleConfigDetails);
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  // fetch detils of payer to edit
  private getPayerDetails() {
    this.isLoader = true;
    const id = this.selectedConfig?.SubscriberId || this.selectedConfig?.payerId;
    const versionId = this.selectedConfig?.versionId || this.selectedConfig?.payerRuleConfigurationVersionId;
    this.ruleService.getRuleConfigDetailsPayer(id, versionId).subscribe({
      next: (response: ApiResponse) => {
        if (response) {
          this.ruleConfigDetails = response?.data?.data;
          this.SetRuleConfigValues(this.ruleConfigDetails);
          this.payerList?.find((el) => {
            if (el?.payerId == this.ruleConfigDetails?.[0]?.payerId) {
              this.addConfigForm?.controls?.['subscriberId']?.patchValue(
                el?.payerName
              );
              this.addConfigForm?.controls?.['subType']?.patchValue('payer');
            }
          });
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  // fetch detils of provider to edit
  private getProvDetails(): void {
    this.isLoader = true;
    const id = this.selectedConfig?.SubscriberId || this.selectedConfig?.providerId;
    const versionId = this.selectedConfig?.versionId || this.selectedConfig?.providerRuleConfigurationVersionId;
    this.ruleService.getRuleConfigDetailsProvider(id, versionId).subscribe({
      next: (response: ApiResponse) => {
        if (response) {
          this.ruleConfigDetails = response?.data?.data;
          this.SetRuleConfigValues(this.ruleConfigDetails);
          this.providerList?.forEach((element) => {
            if (element?.providerId == this.ruleConfigDetails?.[0]?.providerId) {
              this.addConfigForm?.controls?.['subscriberId']?.patchValue(
                element?.providerName
              );
              this.addConfigForm?.controls?.['subType']?.patchValue('provider');
            }
          });
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  //fetch the system rule details
  private getSystemRuleConFigDetails(): void {
    this.isLoader = true;
    const versionId = this.selectedConfig?.ruleConfigurationVersionId;
    this.systemRuleService.getSystemRuleConfigDetails(versionId).subscribe({
      next: (response: ApiResponse) => {
        if (response) {
          this.ruleConfigDetails = response?.data?.data;
          this.SetRuleConfigValues(this.ruleConfigDetails);
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.showSlider = true;
    });
  }

  public closePopup(): void {
    this.close.emit();
  }

  public saveConfig(): void {
    this.submitted = true;
    this.checkEndDate();
    if (this.startError) {
      return;
    }
    if (this.addConfigForm?.valid) {
      this.isLoader = true;
      this.providerId = this.addConfigForm?.controls['subscriberId']?.value?.providerId || this.user?.providerId;
      this.payerId = this.addConfigForm?.controls['subscriberId']?.value?.payerId || this.user?.payerId;

      const validityStart = this.addConfigForm?.value?.validityStart?.split('/').reverse().join('-');
      const validityEndDate = this.addConfigForm?.value?.validityEnd?.split('/').reverse().join('-');
      const payLoad: RuleConfiguration = {
        providerId: this.systemConfigEdit ? null : this.providerId ? this.providerId : '',
        payerId: this.systemConfigEdit ? null : this.payerId ? this.payerId : '',
        subscriberType: this.systemConfigEdit ? null : this.subscriberType ? this.subscriberType : '',
        version: this.addConfigForm?.controls?.['version']?.value,
        clientId: this.ruleConfigDetails[0]?.clientId,
        activeFrom: validityStart,
        expiredOn: validityEndDate,
        configuration: {
          ALLOWREFILL: {
            configDesc: 'Allow refill',
            configValue: this.addConfigForm?.controls['refill']?.value,
            configKey: 'In Days Percentage',
          },
          QUANTITYCALC: {
            configDesc: 'Calculation Based On',
            configValue: 'DAY',
            configKey: 'Type',
          },
          LMTDISPQUNTY: {
            configDesc: 'Limit the dispense quantity to',
            configValue: this.addConfigForm?.controls['dispenseLimit']?.value,
            configKey: 'In Days',
          },
          DRUGSELECTION: {
            configDesc: 'Preffered Drug Selection',
            configValue: this.addConfigForm?.controls['packSize']?.value,
            configKey: 'Type Based',
          },
          MAXREFILL: {
            configDesc: 'Max Number of Refill',
            configValue: this.addConfigForm?.controls['maxDuration']?.value,
            configKey: 'In Number',
          },
          DRUGINHANDCALCULATION: {
            configDesc: 'Drug inHand Calculation',
            configValue: 'NOREFILL',
            configKey: 'DRUGINHANDCALCULATION',
          },
          CONSIDER_DRUG_IN_HAND_METAKEY: {
            configDesc: 'Consider Drug In Hand',
            configValue: this.addConfigForm?.controls['considerDrugInHand']?.value,
            configKey: 'CONSIDER_DRUG_IN_HAND_METAKEY',
          },
          DISPENSETYPE_METAKEY: {
            configDesc: 'Dispense Type Partial or Strip/Packet',
            configValue: this.addConfigForm?.controls['dispenseType']?.value,
            configKey: 'DISPENSETYPE_METAKEY',
          },

        },
      };

      if (!this.systemConfigEdit) {
        if (this.user?.userType == USER_TYPE?.system) {
          if (this.addConfigForm?.controls['subType']?.value === 'payer') {
            this.payerId = this.addConfigForm?.controls['subscriberId']?.value?.payerId;
            this.subscriberType = 'payer';
          }
          else if (this.addConfigForm?.controls['subType']?.value === 'provider') {
            this.providerId = this.addConfigForm?.controls['subscriberId']?.value?.providerId;
            this.subscriberType = 'provider';
          }
        }
        else {
          this.payerId = this.user?.payerId;
          this.providerId = this.user?.providerId;
        }
        this.saveSubscriberConfig(payLoad)
      }
      else {
        this.saveSystemConfig(payLoad)
      }
    }
  }

  // update configurtion
  public updateConfig(): void {
    this.checkEndDate();
    if (this.startError) {
      return;
    }
    if (this.addConfigForm?.valid) {
      this.isLoader = true;
      const payLoad = {
        subscriberType: this.systemConfigEdit ? '' : this.subscriberType === 'provider' ? 3 : 2,
        activeFrom: this.ruleConfigDetails[0]?.activeFrom,
        expiredOn: this.addConfigForm?.controls?.['validityEnd']?.value?.split('/').reverse().join('-'),
      };
      let id = this.ruleConfigDetails[0]?.ruleConfigurationVersionId;
      if (this.subscriberType == 'provider') {
        id = this.ruleConfigDetails[0]?.providerRuleConfigurationVersionId;
      } else if (this.subscriberType == 'payer') {
        id = this.ruleConfigDetails[0]?.payerRuleConfigurationVersionId;
      }
      this.ruleService.editRuleConfig(id, payLoad).subscribe({
        next: (response: ApiResponse) => {
          if (response) {
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: 'Successfully Updated',
            });
            this.isLoader = false;
            this.close.emit();
          }
        },
        error: (error) => {
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error?.message,
          });
          this.isLoader = false;
        },
      });
    }
  }

  private getDrugInHand(): void {
    const payload = {
      per_page: this.page_limit,
      page: this.page_no,
    };
    this.ruleService.getDrugInHandExpiry(payload).subscribe({
      next: (response: ApiResponse) => {
        if (response) {
          this.drugInHand = response?.data?.data;
          this.totalCount = response?.data?.total;
          if (!this.drugInHand?.length) this.showNavigation = true;
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  public currentPageDetail(event: Pagination): void {
    if (event) {
      this.page_no = event?.button_no;
      this.page_limit = event?.item_per_page;
    }
    this.getDrugInHand();
  }

  public checkEndDate(): void {
    if (this.addConfigForm?.controls['validityStart'].value && this.addConfigForm?.controls['validityEnd'].value) {
      const validityStart = this.addConfigForm?.controls['validityStart']?.value?.split('/').reverse().join('-');
      const start = validityStart ? new Date(validityStart).getTime() : null;
      const validityEnd = this.addConfigForm?.controls['validityEnd']?.value?.split('/').reverse().join('-');
      const end = validityEnd ? new Date(validityEnd).getTime() : null;
      if (start && end && start > end) {
        this.startError = true;
      }
      else {
        this.startError = false;
      }
    }
  }

  // api to save new subscriber rule ;
  private saveSubscriberConfig(payLoad: RuleConfiguration): void {
    if (this.addConfigForm?.controls['subType']?.value == 'payer' || this.user?.payerId) {
      this.ruleService.saveRuleConfigPayer(payLoad).subscribe({
        next: (response: ApiResponse) => {
          if (response) {
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: 'Successfully Added',
            });
            this.isLoader = false;
            this.close.emit();
          }
        },
        error: (error) => {
          this.isLoader = false;
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error?.message,
          });
        },
      });
    }
    else if (this.addConfigForm?.controls['subType']?.value == 'provider' || this.user?.providerId) {
      this.ruleService.saveRuleConfigProvider(payLoad).subscribe({
        next: (response: ApiResponse) => {
          if (response) {
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: 'Successfully Added',
            });
            this.isLoader = false;
            this.close.emit();
          }
        },
        error: (error) => {
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error?.message,
          });
          this.isLoader = false;
        },
      });
    }
  }

  private saveSystemConfig(payLoad: RuleConfiguration): void {
    this.systemRuleService.saveSystemRuleConfig(payLoad).subscribe({
      next: (response: ApiResponse) => {
        if (response.status === "Success") {
          if (response.error_code === 0) {
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: "Successfully Added"
            });
            this.isLoader = false;
            this.close.emit();
          }
          else {
            this.toasterandloader.alert.toast({
              title: 'Warning',
              type: 'warning',
              message: response.message
            });
            this.isLoader = false;
          }
        }
      },
      error: (error) => {
        this.isLoader = false;
        this.toasterandloader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error?.message
        });
      },
    })
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  public setDropDownPlaceHolder(): string {
    let placeHolder = 'Linked Payer / Provider';
    if (this.addConfigForm.controls['subType'].value === 'provider' || this.subTypeEvm == this.subTypes.provider ) {
      placeHolder = 'Linked Provider';
    }
    else if (this.addConfigForm.controls['subType'].value === 'payer' || this.subTypeEvm == this.subTypes.payer ) {
      placeHolder = 'Linked Payer';
    }
    return placeHolder;
  }
}
